import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

export default function CTA() {
  const ref = useRef(null);
  const v = useInView(ref, { once: true, margin: '-80px' });

  return (
    <section id="cta" data-testid="cta-section" ref={ref} style={{ padding: 'clamp(120px,16vw,260px) 0', position: 'relative', overflow: 'hidden' }}>
      <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 800, height: 800, background: 'radial-gradient(circle, rgba(255,94,58,0.05) 0%, transparent 50%)', pointerEvents: 'none' }} />

      <div className="container" style={{ position: 'relative', textAlign: 'center' }}>
        <motion.div initial={{ opacity: 0, y: 40 }} animate={v ? { opacity: 1, y: 0 } : {}} transition={{ duration: 1, ease: [0.25, 1, 0.5, 1] }}>
          <h2 data-testid="cta-title" style={{ fontFamily: 'var(--heading)', fontWeight: 800, fontSize: 'clamp(2.5rem, 6vw, 4.5rem)', lineHeight: 1.0, letterSpacing: '-0.04em', marginBottom: 20, color: '#FAFAFA' }}>
            Start using Bonk today
          </h2>
          <p style={{ fontSize: 'clamp(0.95rem, 1.3vw, 1.05rem)', color: '#71717A', lineHeight: 1.7, maxWidth: 400, margin: '0 auto 40px' }}>
            Open source DJ tooling with Rekordbox sync, advanced prep workflows, and faster metadata cleanup.
          </p>

          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <motion.a href="https://github.com/suhaas-lokare/Bonk" target="_blank" rel="noopener noreferrer" data-testid="cta-download-btn"
              whileHover={{ scale: 1.02, boxShadow: '0 8px 24px rgba(0,0,0,0.5)' }} whileTap={{ scale: 0.98 }}
              style={{ background: '#FAFAFA', color: '#09090B', fontWeight: 700, fontSize: 15, padding: '14px 32px', borderRadius: 10, display: 'inline-flex', alignItems: 'center', gap: 8, boxShadow: '0 1px 2px rgba(0,0,0,0.4)', fontFamily: 'var(--heading)' }}
            >Download Bonk <ArrowRight size={16} /></motion.a>

            <motion.a href="https://github.com/suhaas-lokare/Bonk" target="_blank" rel="noopener noreferrer" data-testid="cta-github-btn"
              whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}
              style={{ color: '#A1A1AA', border: '1px solid rgba(255,255,255,0.08)', fontWeight: 600, fontSize: 15, fontFamily: 'var(--heading)', padding: '14px 32px', borderRadius: 10, display: 'inline-flex', alignItems: 'center', gap: 8 }}
            >View on GitHub</motion.a>

            <motion.a href="#contact" data-testid="cta-contact-btn"
              whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}
              onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }}
              style={{ color: '#A1A1AA', border: '1px solid rgba(255,255,255,0.08)', fontWeight: 600, fontSize: 15, fontFamily: 'var(--heading)', padding: '14px 32px', borderRadius: 10, display: 'inline-flex', alignItems: 'center', gap: 8 }}
            >Join waitlist</motion.a>
          </div>

          <div style={{ display: 'flex', justifyContent: 'center', gap: 20, marginTop: 36 }}>
            {['macOS', 'Windows', 'Linux'].map((p, i) => (
              <span key={p} style={{ fontFamily: 'var(--mono)', fontSize: 11, color: '#3F3F46', fontWeight: 500, letterSpacing: '0.05em' }}>{p}</span>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
